// Pure timestamp/timeline math. `stamps` is (number|null)[] parallel to the
// move list; times are seconds.

// Tagged moves sorted by time (ties: later move index wins when searched).
export function taggedTimeline(stamps) {
  const entries = []
  for (let index = 0; index < (stamps?.length ?? 0); index++) {
    const time = stamps[index]
    if (time != null) entries.push({ time, index })
  }
  entries.sort((a, b) => a.time - b.time || a.index - b.index)
  return entries
}

// Index of the move whose position should be on the board at `time`:
// the tagged move with the greatest timestamp <= time. -1 = start position.
export function activeIndexAt(stamps, time) {
  const timeline = taggedTimeline(stamps)
  let lo = 0
  let hi = timeline.length - 1
  let found = -1
  while (lo <= hi) {
    const mid = (lo + hi) >> 1
    if (timeline[mid].time <= time) {
      found = mid
      lo = mid + 1
    } else {
      hi = mid - 1
    }
  }
  return found === -1 ? -1 : timeline[found].index
}

// Returns a NEW stamps array with every tagged stamp at fromIndex or later
// shifted by delta seconds (clamped at 0). Used to fix sync drift.
export function shiftStamps(stamps, { fromIndex, delta }) {
  return stamps.map((time, index) => {
    if (time == null || index < fromIndex) return time
    return Math.max(0, time + delta)
  })
}

// Indices whose stamp is earlier than a preceding tagged stamp (out of order).
export function violations(stamps) {
  const out = []
  let maxSoFar = -Infinity
  for (let i = 0; i < (stamps?.length ?? 0); i++) {
    const time = stamps[i]
    if (time == null) continue
    if (time < maxSoFar) out.push(i)
    else maxSoFar = time
  }
  return out
}
